export default class NavBar {
  /**
   * Used for controlling the navigation bar.
   * @param {Element} navigationElement The nav element for the navigation bar.
   */
  constructor(navigationElement) {
    /**
     * @type {Element} The root element for the navigation.
     * @private
     */
    this._elRoot = navigationElement;

    /**
     * @type {Element} The mobile hamburger menu icon, used for toggling the navigation bar.
     * @private
     */
    this._elHamburger = this._elRoot.querySelector('.hamburger-ico');

    /**
     * @type {Element} The navigation url list.
     * @private
     */
    this._elNavUl = this._elRoot.querySelector('.menu');

    this._attachEventListeners();
  }

  /**
   * Attach event listeners to the navigation bar, allowing for easy removal.
   * @private
   */
  _attachEventListeners() {
    let t = this;
    this._elHamburger.addEventListener('click', function(event) { t._elHamburgerClick(event); });
    this._elNavUl.addEventListener('click', function(event) { t._elNavUlClick(event); });
  }

  _elNavUlClick(event) {
    this.closeMobileNavBar();
  }

  /**
   * Click listener for when the hamburger menu item is clicked.
   * @private
   */
  _elHamburgerClick(event) {
    event.stopPropagation();
    this.toggleMobileNavBar();
  }

  /**
   * Check to see if the navigation bar is open.
   * @return {boolean} true if the navigation bar is open.
   */
  isMobileNavBarOpen() {
    return this._elHamburger.classList.contains('open');
  }

  /**
   * Close the mobile nav menu.
   */
  closeMobileNavBar() {
    if (!this.isMobileNavBarOpen()) {
      return; // No need to do anything, navbar is already closed.
    }
    this._elHamburger.classList.remove('open');
    this._elHamburger.classList.add('close');
    this._elNavUl.classList.add('close');
    this._elNavUl.classList.add('animate-close');
    this._elNavUl.classList.remove('open');
    this._elNavUl.addEventListener('animationend', () => {
      this._elNavUl.classList.remove('animate-close');
    }, { once: true });
  }
  /**
   * Open the mobile nav menu.
   */
  openMobileNavBar() {
    if (this.isMobileNavBarOpen()) {
      return; // No need to do anything, navbar already open.
    }
    this._elHamburger.classList.add('open');
    this._elHamburger.classList.remove('close');
    this._elNavUl.classList.add('open');
    this._elNavUl.classList.add('animate-open');
    this._elNavUl.classList.remove('close');
    this._elNavUl.addEventListener('animationend', () => {
      this._elNavUl.classList.remove('animate-open');
    }, { once: true });
  }

  /**
   * Toggle the mobile nav bar open/close state.
   */
  toggleMobileNavBar() {
    if (this.isMobileNavBarOpen()) {
      this.closeMobileNavBar();
    } else {
      this.openMobileNavBar();
    }
  }
}



// WEBPACK FOOTER //
// ./src/class/NavBar.js